import { LocationData } from "./locationData";

export class Customer {
  customerCode!: string;
  customerNumber!: string;
  firstName!: string;
  lastName!: string;
  fullName!: string;
  phone!: string;
  email!: string;
  customerType!: number;
  address!: string;

  title!: string;
  birthDate!: string;
  branch!: number;
  sensitiveStatus!: boolean | null;
  protectedStatus!: boolean | null;
  gender!: number | null;
  group!: number | null;
  customerStatus!: number | null;
  maritalStatus!: number | null;
  language!: number | null;  
  emailType!: number | null;
  phoneNumber!: string;
  phoneType!: number | null;
  street!: string;
  streetNumber!: string;
  zipCode!: string;
  region!: number | null;
  city!: number | null;
  state!: number | null;
  country!: number | null;
  addressType!: number | null;
  salutation!: number | null;
  acquisitionStatus!: number | null;
  acquisitionSubStatus!: number | null;
  leadSource!: number | null;
  companySize!: number | null;
  companyIndustryType!: number | null;
  employmentRole!: number | null;
  jobTitle!: string;
  decisionMakerStatus!: boolean | null;
  externalReference1!: string;
  externalReference2!: string;

  locationAddress!: LocationData;

  constructor(data?: any) {
    if (data) {
      this.customerCode = data.details.customerCode;
      this.customerNumber = data.details.customerNumber;
      this.firstName = data.details.firstName;
      this.lastName = data.details.lastName;
      this.fullName = data.details.fullName;
      this.phone = data.details.primaryPhoneNumber;
      this.email = data.details.primaryEmail;
      this.customerType = data.details.typeId;
      this.address = data.details.primaryAddress + ' ' + data.details.primaryAddressStreetNumber;
      this.locationAddress = new LocationData(data.details);



      this.title=data.details.title;
      this.birthDate=data.details.dateOfBirth;
      this.branch=data.details.branch;
      this.sensitiveStatus=data.details.isSensitive;
      this.protectedStatus=data.details.isProtected;
      this.gender=data.details.genderId;
      this.group=data.details.groupId;
      this.customerStatus=data.details.statusId;
      this.maritalStatus=data.details.maritalStatusId;
      this.language= data.details.languageId;
      this.emailType= data.emails[0]?.emailTypeId;//Check if this is primary email.
      this.phoneNumber=data.details.primaryPhoneNumber;
      this.phoneType=data.phones[0]?.phoneTypeId;//Check if this is primary phone type.
      this.street=data.details.primaryAddress;
      this.streetNumber=data.details.primaryAddressStreetNumber;
      this.zipCode=data.details.primaryAddressZipCode;
      this.region=data.details.primaryAddressRegionId;
      this.city=data.details.primaryAddressCityId;
      this.state=data.details.primaryAddressStateId;
      this.country=data.details.primaryAddressCountryId;
      this.addressType= data.addresses[0]?.addressTypeId;//Check if this is primary address.
      this.salutation=data.details.salutationId;
      this.acquisitionStatus=data.details.acquisitionStatusId;
      this.acquisitionSubStatus=data.details.acquisitionSubstatusId;
      this.leadSource=data.details.leadSourceId;
      this.companySize=data.details.companySizeId;
      this.companyIndustryType=data.details.companyIndustryTypeId;
      this.employmentRole=data.details.employmentRoleId;
      this.jobTitle=data.details.jobTitle;
      this.decisionMakerStatus=data.details.isDecisionMaker;
      this.externalReference1=data.details.externalReference1;
      this.externalReference2=data.details.externalReference3;
    }
  }
}